import { render, staticRenderFns } from "./CookingMenuButton.vue?vue&type=template&id=7a1a8e4d&"
import script from "./CookingMenuButton.vue?vue&type=script&lang=js&"
export * from "./CookingMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports